import { DbRecordService } from './db-record.service'
import { Tag } from './tag'
import { CriterionItem } from './criterion-item'


export class DbRecord {
  static exportIdCounter = 1
  id: string
  exportId: string
  isRepaired = false
  _isManual = false

  _recordId: string
  _sourceDb: string
  __sourceDb: string
  _title: string
  _abstract: string
  _authors: string[]
  _doi: string | string[]
  _issn: string | string[]
  _lang: string | string[]
  _url: string | string[]
  _source: string
  _volume: string
  _issue: string
  _year: number
  _startPage: string
  _endPage: string
  _applicationNumber: string
  _priorityNumber: string
  _publicationNumber: string
  _priorityDate: string

  _keys: string[]
  _searchCode: string
  _position: number
  _criterionTitle: string
  _criterionAbstract: string
  publicationNumbers = []
  patentCountries = new Set<string>()
  patentStages = new Set<string>()


  constructor(
    private dbrs: DbRecordService,
    params: Object
  ) {
    this.exportId = `exp${DbRecord.exportIdCounter++}`
    let repairParams = this.dbrs.getRepairObject(params['recordId'])

    if (repairParams) {
      this.isRepaired = true
      Object.keys(repairParams).forEach((x) =>
        params[x] = repairParams[x])
    }

    this.update(params)
    this.id = this._recordId

    if (this.dbrs.currentExcludeRecordsSet.has(this.id)) {
      return;
    }
    this._sourceDb = this.__sourceDb

    if (!this._keys)
      this._keys = []

    if (this._sourceDb == 'espacenet') {
      this.dbrs.rts.currentProject.hasPatents = true
      this._keys.push(this._applicationNumber)
      this._publicationNumber.replace(/[^A-Za-z0-9\(\);]/g, '').split(';').forEach(x => {
        let i = x.indexOf('(')
        if (i > 3) {
          let stg = x.slice(i + 1, -1)
          this.patentStages.add(stg)
        }
        let pn = x.replace(/[\(\)]/g, '')
        this.publicationNumbers.push(pn)
        this.patentCountries.add(pn.slice(0, 3).replace(/\d/g, ''))
      })
      this.dbrs.ps.processDbRecord(this)
    }

    this.dbrs.addDbRecord(this)
  }

  update(obj) {
    Object.keys(obj).forEach((k) => this["_" + k] = obj[k])
  }

  exportRow(tpl) {
    if (tpl[1] === null || tpl[1] === undefined)
      return null
    let tag = tpl[0]
    let items = tpl[1]
    if (typeof items == 'string')
      items = [items]
    return items.map(x => `${tpl[0]}  - ${x.trim()}`).join('\n')
  }

  exportForHTML() {
    let authors = this.authors.length ?
      `<div>${this.authors.join('; ')}</div>` : ''
    return `
    <p>
      <div><b>${this.title}</b></div>${authors}
      <div>${this.shortCitationText}</div>
      <div>${this.abstract}</div>
    </p>
    `
  }

  exportForJSON() {
    let dct = {}
    let fields = ['authors', 'title', 'abstract', 'source',
      'volume', 'issue', 'startPage', 'endPage', 'year',
      'doi','_sourceDb'
    ]


    dct['id'] = this.dbrs.utils.jsonRecordId(this.recordId)

    fields.forEach(x => {
      if (this[x])
        dct[x] = this[x]
    })
    return dct
  }

  static exportForCSVHeaders() {
    return ['Authors', 'Title', 'Source', 'Volume', 'Issue', 'Start page', 'End page',
      'Year', 'DOI', 'Abstract']
  }

  exportForCSV() {
    return [
      (this.authors || []).join(';'),
      this.title || '',
      this.source || '',
      this.volume || '',
      this.issue || '',
      this.startPage || '',
      this.endPage || '',

      this.year ? this.year.toString() : '',
      this.doi || '',
      this.abstract || '',
    ]
  }

  export() {
    let ls = []
    let tags = [
      ["TY", "JOUR"],
      ["TI", this.title],
      ["T2", this.source],
      ["VL", this.volume],
      ["IS", this.issue],
      ["SP", this.startPage],
      ["EP", this.endPage],
      ["AU", this.authors],
      ["PY", this.year ? this.year.toString() : null],
      ["DO", this.doi],
      ["AB", this.abstract],
      ["UR", this.exportId],
      ["ER", ""]
    ]
    tags.forEach(tpl => {
      let txt = this.exportRow(tpl)
      if (txt)
        ls.push(txt)
    })
    return ls.join('\n')
  }

  seed() {
    let dct = {}
    let fields = [
      'recordId',
      'sourceDb',
      'title',
      'abstract',
      'authors',
      'doi',
      'url',
      'issn',
      'lang',
      'source',
      'volume',
      'issue',
      'year',
      'startPage',
      'endPage']

    fields.forEach((x) => dct[x] = this[x])
    return dct
  }

  criterionText(txt: string) {
    if (!txt)
      return ''
    return txt.toLowerCase().replace(/[^a-z0-9-]/g, ' ').replace('\s+', ' ').trim()
  }

  clearCriterionTextCache() {
    this._criterionTitle = null
    this._criterionAbstract = null
  }

  get criterionTitle() {
    if (!this._criterionTitle)
      this._criterionTitle = this.criterionText(this.title)
    return this._criterionTitle
  }

  get criterionAbstract() {
    if (!this._criterionAbstract)
      this._criterionAbstract = this.criterionText(this.abstract)
    return this._criterionAbstract
  }

  sortTuple(ls) {
    let tuple = []
    ls.map((x) => {
      switch (x) {
        case 'dateAsc':
          tuple.push(this.year);
          break;
        case 'dateDesc':
          tuple.push(-1 * this.year);
          break;
        case 'source':
          tuple.push(this.source);
          break;
        default:
          let v = this.dbrs.getCriterion(x).run(this);
          tuple.push(v)
      }
    })
    return tuple
  }

  hasTags(tags: Set<Tag>, isOr?: boolean) {
    let ls = Array.from(tags)

    for (let t of ls) {
      if (t.id == '_manual') {
        if (this._isManual)
          continue
        else
          return false
      }
      let hasTag = t.taggedItems.has(this.id)
      if (hasTag && isOr)
        return true
      if (!hasTag && !isOr)
        return false
    }

    return !isOr
  }

  hasCountry(countries: Set<string>) {
    let flag = false
    this.patentCountries.forEach(x => {
      if (countries.has(x))
        flag = true
    })
    return flag
  }

  hasStage(stages: Set<string>) {
    let flag = false
    this.patentStages.forEach(x => {
      if (stages.has(x))
        flag = true
    })
    return flag
  }

  excludeTags(tags: Set<Tag>) {
    let ls = []
    tags.forEach((v) => ls.push(v))
    for (let t of ls)
      if (t.taggedItems.has(this.id))
        return false
    return true
  }

  sourceHit(regexp: RegExp) {
    return regexp.test(this.source)
  }

  regexpHit(regexp: RegExp) {
    if (regexp.test(this.title))
      return true
    if (regexp.test(this.abstract || ''))
      return true
    if (this.patentHit(regexp))
      return true
    return false
  }

  patentHit(regexp: RegExp) {
    if (!this._applicationNumber)
      return false
    for (let i = 0; i < this.publicationNumbers.length; i++)
      if (regexp.test(this.publicationNumbers[i]))
        return true
    return regexp.test(this._priorityNumber) ||
      regexp.test(this._applicationNumber)
  }

  get searchCode() {
    return this._searchCode
  }

  get keys() {
    return this._keys
  }

  get recordId() {
    return this._recordId || this.id
  }

  get authors() {
    return this._authors || []
  }

  get authorsCitation() {
    return this.authors.join('; ')
  }

  get doi() {
    if (!this._doi)
      return null
    if (typeof this._doi == 'string')
      return this._doi
    return this._doi[0]
  }

  get url() {
    if (!this._url)
      return null
    if (typeof this._url == 'string')
      return this._url
    return this._url[0]
  }

  get issn() {
    return this._issn
  }

  get lang() {
    return this._lang
  }

  get source() {
    return this._source
  }

  get volume() {
    return this._volume
  }

  get issue() {
    return this._issue
  }

  get year() {
    return this._year
  }

  get title() {
    return this._title
  }

  get startPage() {
    return this._startPage
  }

  get endPage() {
    return this._endPage
  }

  get abstract() {
    return this._abstract
  }

  get scVolume() {
    let v = this.volume
    if (!v)
      return ''
    if (!this.issue)
      v += ','
    return v
  }


  get scIssue() {
    if (!this.issue)
      return ''
    return `(${this.issue}),`
  }

  get scStartPage() {
    let p = this.startPage
    if (!p)
      return '.'
    if (!this.endPage)
      p += '.'
    return p
  }

  get scEndPage() {
    if (!this.endPage)
      return ''
    return `-${this.endPage}.`
  }

  get applicationNumber() {
    return this.dbrs.fs.highlightSearchHits(this._applicationNumber)
  }

  get priorityNumber() {
    return this.dbrs.fs.highlightSearchHits(this._priorityNumber)
  }

  get publicationNumber() {
    let ls = []
    this.publicationNumbers.forEach(x => {
      ls.push(`<div class="pnDiv">
        ${this.dbrs.fs.highlightSearchHits(x)}
        ${this.patentLinks(x)}
        </div>`)
    })
    return ls.join('')
  }

  get priorityDate() {
    return `${this._priorityDate.slice(0, 4)}-${this._priorityDate.slice(4, 6)}-${this._priorityDate.slice(6)}`
  }

  /*    kt,
          `http://worldwide.espacenet.com/publicationDetails/biblio?CC=${code
          }&NR=${k.slice(2) + t}&KC=${t}&FT=D`,
          `https://patents.google.com/patent/${kt}`,
          `https://www.google.com/search?q=${kt}`,
          code == 'WO' ? `https://patentscope.wipo.int/search/en/detail.jsf?docId=${k}` : null */

  patentLinks(pn: string) {
    let indices = []
    let charCode

    for (var i = 0; i < pn.length; i++) {
      charCode = pn.charCodeAt(i);
      let isNumber = charCode >= 48 && charCode <= 57 // 0-9
      if (isNumber && !indices.length)
        indices.push(i)
      else if (!isNumber && indices.length) {
        indices.push(i)
        break
      }
    }

    let nmb = pn.slice(indices[0], indices[1])
    let code = pn.slice(0, indices[0])
    let tp = pn.slice(indices[1])

    let results = []
    results.push(`<a target="blank"  href="http://worldwide.espacenet.com/publicationDetails/biblio?CC=${code
      }&NR=${nmb + tp}&KC=${tp}&FT=D">ESPACENET</a>`)
    results.push(`<a target="blank"  href="https://patents.google.com/patent/${code}${nmb}${tp}">Google Patent</a>`)
    results.push(`<a target="blank"  href="https://www.google.com/search?q=${code}${nmb}">Google</a>`)
    results.push(`<a target="blank"  href="https://patentscope.wipo.int/search/en/detail.jsf?docId=${code}${nmb}">PatentScope</a>`)
    return results.join("; ")
  }

  get patentCitation() {
    return `<table>
    <tr><td>Publication number:</td><td>${this.publicationNumber}</td></tr>
    <tr><td>Application number:</td><td>${this.applicationNumber}</td></tr>
    <tr><td>Priority number:</td><td>${this.priorityNumber}</td></tr>
    <tr><td>Priority date:</td><td>${this.priorityDate}</td></tr>
    </table>`
  }

  get patentFamily() {
    let s = new Set<DbRecord>()
    this.publicationNumbers.forEach(x => {
      let ps = this.dbrs.patentFamilyMap.get(x)
      if (ps)
        ps.forEach(y => s.add(y))
    })
    return Array.from(s)
  }


  get hasPatentFamily() {
    if (!this.publicationNumber)
      return false
    for (let i = 0; i < this.publicationNumbers.length; i++)
      if (this.dbrs.patentFamilyMap.has(this.publicationNumbers[i]))
        return true
    return false
  }

  get shortCitationText() {
    if (this.applicationNumber)
      return this.patentCitation
    let doi
    let url
    if (this.doi)
      doi = ` [doi: ${this.doi}]`
    else
      doi = ''

    if (this.url)
      url = ` [url: ${this.url}]`
    else
      url = ''

    return `${this.source}, ${this.year}, ${this.scVolume}${this.scIssue}
    ${this.scStartPage}${this.scEndPage}
    ${doi}
    ${url}`
  }


  get shortCitation() {
    if (this.applicationNumber)
      return this.patentCitation
    let doi
    let url

    if (this.doi)
      doi = ` [<a target='_blank' href='http://dx.doi.org/${this.doi}'>${this.doi}</a>]`
    else
      doi = ''

    if (this.url)
      url = ` [url: <a target='_blank' href='${this.url}'>${this.url}]`
    else
      url = ''

    return `${this.source}, <span class='year'>${this.year}</span>, ${this.scVolume}${this.scIssue}
    ${this.scStartPage}${this.scEndPage}
    ${doi}
    ${url}`
  }

  get search() {
    let searchLs = []
    searchLs.push(`<a href="http://scholar.google.com/scholar?q=${encodeURIComponent(`"${this.title}"`)}" target="_blank">Scholar for title</a>`)
    if (this.doi)
      searchLs.push(`<a href="http://scholar.google.com/scholar?q=${encodeURIComponent(this.doi)}" target="_blank">Scholar for DOI</a>`)
    searchLs.push(`<a href="http://google.com/?q=${encodeURIComponent(`"${this.title}"`)}" target="_blank">Google for title</a>`)
    if (this.doi)
      searchLs.push(`<a href="http://google.com/?q=${encodeURIComponent(this.doi)}" target="_blank">Google for DOI</a>`)

    return searchLs.join(' | ')
  }

}



// WEBPACK FOOTER //
// ./src/app/db-record.ts